import React from "react";
import "./overlay.scss";

export default function Overlay() {
  return <div id='overlay'></div>;
}
